import { ApplicationState } from '@/platform/ApplicationState';
import { GlobalStore } from '@/store/global';
import { computed } from 'vue';
import { Visa } from '@/presenters/Visa';

export class StudyCB {
	public isApplicationReady = computed<boolean>(() => {
		const result = GlobalStore.getters.getApplicationState() === ApplicationState.READY;
		return result;
	});

	public isApplicationIdle = computed<boolean>(() => {
		return GlobalStore.getters.getApplicationState() === ApplicationState.IDLE;
	});

	public originCountryDemonym = computed<string | null | undefined>(() => {
		return GlobalStore.getters.getVisa()?.originCountry.demonym;
	});

	public destinationCountryName = computed<string | null | undefined>(() => {
		return GlobalStore.getters.getVisa()?.destinationCountry.name;
	});

	public visa = computed<Visa | null>(() => {
		return GlobalStore.getters.getVisa();
	});

	public countryUrl = computed<string | undefined>(() => {
		const country = GlobalStore.getters.getVisa()?.destinationCountry;

		if (!country) {
			return undefined;
		}

		const countryPath = country?.path;
		if (countryPath) {
			return `/countries/${country.id}/${countryPath}.html`;
		}
		return `/countries/${country.id}`;
	});

	public openLocalizationSettings(): void {
		GlobalStore.actions.openLocalizationSettings();
	}
}
